module.exports = __webpack_public_path__ + "img/Weapon_232.1fd39395.png";